






























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import iconMap from '@assets/svg/iconMap';
import ILink from '@frontend/types/base/ILink';

@Component({
	componentId: 'C005'
})
export default class IconTextLink extends Vue {
	@Prop(Object)
	protected readonly link?: ILink;

	@Prop(String)
	protected readonly label?: string;

	// For Route-Links
	@Prop([String, Object])
	protected readonly to?: string | any;

	@Prop(String)
	protected readonly icon?: string;

	@Prop(String)
	protected readonly variant?: string;

	@Prop(String)
	protected readonly tag?: string;

	@Prop(String)
	protected readonly fontStyle?: string;

	protected hasDefaultSlot(): boolean {
		return !!this.$slots.default;
	}

	protected get type(): string {
		if (this.tag) {
			return this.tag;
		}

		if (this.link) {
			return 'a';
		}

		return 'button';
	}

	protected get buttonLabel(): string | null {
		if (this.label) {
			return this.label;
		}

		if (this.link) {
			return this.link.label as string;
		}

		return null;
	}

	protected get iconComponent(): Promise<any> | null {
		if (!this.icon) {
			return null;
		}
		return iconMap[this.icon];
	}
}
